export const featrueType = {
    OBJECT_FACE: 'faceAttributes',
    'FACE&BODY': 'faceAttributes',
    OBJECT_PEDESTRIAN: 'pedestrianAttributes',
    'BODY&FACE': 'pedestrianAttributes',
    OBJECT_AUTOMOBILE: 'vehicleAttributes',
    OBJECT_HUMAN_POWERED_VEHICLE: 'nonMotorVehicleAttributes',
};
